<template>
  <div id="app-top">
    <div class="top-box">
      <!-- <h3>
        您的位置：首页 > 爱眼项目 >
        <span>合作项目</span>
      </h3>-->
      <h3 v-if="bread2">
        您的位置：{{bread1}} >{{bread2}}>
        <span>详情</span>
      </h3>
      <h3 v-else>
        您的位置：{{bread1}}>
        <span>详情</span>
      </h3>
      <div class="content-box">
        <div class="content-l">
          <img :src="projectData.news_pic_id_url" alt />
        </div>
        <div class="content-r">
          <h3>{{projectData.news_title}}</h3>
          <p
            style="text-index;text-indent:2em;margin-top:15px;white-space:pre-line;max-height:260px;overflow:auto"
          >{{projectData.description}}</p>

          <!-- <div class="pro-box">
            <div class="pro-l">
              <p>已筹到</p>
              <h3>
                <span>￥</span>3130108.22
              </h3>
            </div>
            <div class="pro-r">
              <p>目标筹款</p>
              <h3>
                <span>￥</span>5000000
              </h3>
            </div>
          </div>-->
          <!-- <div class="el_box">
            <el-progress :percentage="80" color="#c30d23"></el-progress>
          </div>
          <div class="amount-box">
            <p>金额</p>
            <div class="btn_box">
              <button>￥20</button>
              <button>￥50</button>
              <button>￥100</button>
              <button>￥200</button>
              <div class="ipt-box">
                <input type="text" placeholder="其他金额">
                <span>元</span>
              </div>
            </div>
          </div>
          <div class="donation-btn">
            <button>我要捐赠</button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    projectData: {
      type: Object
    }
  },
  data() {
    return {
      bread2: "",
      bread1: ""
    };
  },
  created() {
    ///根据一级id获取二级导航
    let that = this;
    if (that.$route.query.cid) {
      this.$db
        .post(this.$db.config.getChildByChidUrl, { id: this.$route.query.cid })
        .then(res => {
          res.data.forEach((item, index) => {
            if (item.id == that.$route.query.cid) {
              that.bread1 = item.channel_title;
            }
            if (item.id == that.$route.query.tabid) {
              that.bread2 = item.channel_title;
            }
          });
        });
    }
  }
};
</script>


<style lang="scss" scoped>
#app-top {
  width: 100%;
  margin-bottom: 50px;
}
.top-box {
  width: 1300px;
  margin: 0 auto;
  > h3 {
    font-size: 14px;
    color: #999;
    text-align: right;
    font-weight: normal;
    padding: 28px 0 17px;
    > span {
      color: #333333;
    }
  }
  .content-box {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .content-l {
      width: 400px;
      height: 300px;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    .content-r {
      width: 60%;
      padding-top: 20px;
      margin-right: 30px;
      > h3 {
        font-size: 30px;
        color: #030200;
        margin-bottom: 18px;
      }
      > p {
        font-size: 16px;
        color: #999999;
        padding-bottom: 15px;
        // border-bottom: 1px solid #eaeaea;
        line-height: 28px;
      }
      .pro-box {
        display: flex;
        margin-top: 46px;
        padding-right: 170px;
        .pro-l {
          width: 50%;
          > p {
            color: #030200;
            font-size: 14px;
          }
          > h3 {
            font-size: 24px;
            font-weight: normal;
            color: #333333;
            > span {
              color: #030200;
              font-size: 14px;
            }
          }
        }
        .pro-r {
          > p {
            color: #030200;
            font-size: 14px;
          }
          > h3 {
            font-size: 24px;
            font-weight: normal;
            color: #c30d23;
            > span {
              color: #c30d23;
              font-size: 14px;
            }
          }
        }
      }
      .el_box {
        margin-top: 20px;
      }
      .amount-box {
        margin-top: 24px;
        > p {
          font-size: 14px;
          color: #030200;
          margin-bottom: 10px;
        }
        .btn_box {
          display: flex;
          justify-content: space-between;
          > button {
            margin: 0;
            padding: 0;
            outline: none;
            border: none;
            width: 80px;
            height: 35px;
            border: solid 1px #cccccc;
            line-height: 35px;
            text-align: center;
            background-color: #fff;
          }
          .ipt-box {
            width: 309px;
            height: 35px;
            position: relative;
            padding: 0 36px 0 12px;
            border: solid 1px #cccccc;
            > span {
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              font-size: 16px;
              color: #333333;
            }
            > input {
              margin: 0;
              padding: 0;
              outline: none;
              border: none;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .donation-btn {
        margin-top: 50px;
        > button {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          padding: 13px 32px;
          font-size: 20px;
          color: #ffffff;
          background-color: #c30d23;
          box-shadow: 2px 3px 10px 0px rgba(9, 1, 4, 0.21);
          border-radius: 6px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Project_details/details_top.vue